var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M5 16L0 9h10l-5 7zM5 0l5 7H0l5-7z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }